/**
 * 统一配置组件插件化 异步注册组件
 * 规范化命名 避免冲突 避免过多代码修改
 * 后续有组件需要处理 只需在这里注册
 *
 * 将某些常用的组件集成提供更简单的调用
 *
 * 插件可用方法由插件内置 这里统一定义关键字
 */
import Vue from 'vue';
// 插件信息
import modalPlugin from './modal/index';
import selectLocationPlugin from './select-location/index';
import valueListPlugin from './value-list/index';
import selectDatePlugin from './select-date';
import baseSlideSelectPlugin from './base-side-select/index';
import listSelectorPlugin from 'components/base-ui-v3/chooser/list-selector/index';
import treeSelectorPlugin from 'components/base-ui-v3/tree-select/tree-selector/index';
const plugins = [
  modalPlugin,
  selectLocationPlugin,
  valueListPlugin,
  selectDatePlugin,
  baseSlideSelectPlugin,
  listSelectorPlugin,
  treeSelectorPlugin,
];

const plugin = {
  install() {
    plugins.forEach((item) => {
      Vue.use(item);
    });
    if (!Vue.prototype.$plugins) {
      Vue.prototype.$plugins = {};
    }
    Object.assign(Vue.prototype.$plugins, {
      modal: modalPlugin,
      valueList: {
        show: valueListPlugin.show,
        close: valueListPlugin.close,
      },
      listSelector: listSelectorPlugin,
      treeSelector: treeSelectorPlugin,
      selectLocation: selectLocationPlugin,
      selectDate: selectDatePlugin,
      baseSlideSelect: baseSlideSelectPlugin,
    });
  },
};

export default plugin;
